import React from "react";
import { LineChart, Line, ResponsiveContainer, Tooltip } from "recharts";

export function SparklineChart({ data, color }) {
  const chartData = data?.map((v, i) => ({ i, v }));
  return (
    <div style={{ height: 40 }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chartData}>
          <Line
            type="monotone"
            dataKey="v"
            stroke={color}
            strokeWidth={2}
            dot={false}
            isAnimationActive={false}
          />
          <Tooltip
            contentStyle={{ display: "none" }}
            cursor={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}